import React from "react";
import GenerateApiKey from "../../hooks/agent_management/GenrateApiKey";
import { ViewAttachmentModal } from "../common/ViewAttachmentModal";
import { StaticQRcode } from "../../hooks/qr_codes/StaticQRcode";
import IframeKeyGeneration from "../../hooks/agent_management/IframeKeyGeneration";
import DisbursementSettings from "../pages/settings/DisbursementSettings";
import { USSDHealthCheck } from "../../hooks/ussd_services/USSDHealthCheck";
import { DisbursementHealthCheck } from "../../hooks/disbursement_service/DisbursementHealthCheck";
import CheckPaymentStatus from "../pages/utility_payments/CheckPaymentStatus";
import FloatInterestStatementModal from "../../hooks/finance_and_treasury/revenue_sharing/FloatInterestStatementModal";
import { SettlementEligibilityModal } from "../../hooks/finance_and_treasury/settlement_engine/SettlementEligibilityModal";

const Modals: React.FC = () => {
  return (
    <>
      <GenerateApiKey />
      <IframeKeyGeneration />
      <ViewAttachmentModal />
      <StaticQRcode />
      <DisbursementSettings />
      <USSDHealthCheck />
      <DisbursementHealthCheck />
      <CheckPaymentStatus />
      <FloatInterestStatementModal />
      <SettlementEligibilityModal />
    </>
  );
};

export default Modals;
